const UserInfoKey = 'fudan_keti_user_info'

import './storage'

export function getUserInfo() {
  return JSON.parse(localStorage.getExpire(UserInfoKey))
}

export function setUserInfo(user) {
  return localStorage.setExpire(UserInfoKey, JSON.stringify(user),24*60*60*1000)
}

export function removeUserInfo() {
  return localStorage.removeItem(UserInfoKey)
}



// WEBPACK FOOTER //
// ./src/utils/userInfo.js